module.exports = __webpack_public_path__ + "fonts/Inter-900-greek-ext80.2d64d8a.woff2";